import gql from 'graphql-tag';

export const CreateParticipant = gql`
  mutation CreateParticipant($request: CreateParticipantRequest!) {
    createParticipant(request: $request) {
      id
    }
  }
`;
